import React from "react";
import { createRoot } from "react-dom/client";
import StarguessrApp from "../components/starguessr/StarguessrApp.jsx";

const root = createRoot(document.getElementById("root"));
root.render(<StarguessrApp />);
